/**
 * O botão "Criar canais padrão" da aba Canais: a base de canais de rede
 * com que a empresa nova nasce (`core/network_channels.py`), aplicada na
 * empresa aberta. O servidor só cria o que falta e nunca recria canal
 * desativado; esta função só diz o que aconteceu, numa frase.
 */
import type { Channel } from "@/shared/api/api-client";

/** O que o botão cria, pra o `title` dizer antes do clique. */
export const STANDARD_NETWORK_CHANNEL_NAMES = [
  "Facebook",
  "Instagram",
  "YouTube",
  "Twitter (apelido X)",
  "Comentários no Facebook",
  "Comentários no Instagram",
  "Comentários no YouTube",
] as const;

export interface StandardNetworkChannelsResult {
  created: Channel[];
  aliased: Channel[];
  kept_inactive: string[];
}

function joinNames(names: string[]): string {
  if (names.length <= 1) return names.join("");
  return `${names.slice(0, -1).join(", ")} e ${names[names.length - 1]}`;
}

export function standardChannelsNotice(result: StandardNetworkChannelsResult): string {
  const parts: string[] = [];
  const created = result.created.map(channel => channel.name);
  if (created.length === 1) {
    parts.push(`1 canal padrão criado: ${created[0]}.`);
  } else if (created.length > 1) {
    parts.push(`${created.length} canais padrão criados: ${joinNames(created)}.`);
  }
  const aliased = result.aliased.map(channel => channel.name);
  if (aliased.length > 0) {
    parts.push(`${joinNames(aliased)} ganhou o apelido X.`);
  }
  const kept = result.kept_inactive;
  if (kept.length === 1) {
    parts.push(
      `${kept[0]} está desativado e não foi recriado; se quiser de volta, reative pela lista com "Mostrar desativados".`
    );
  } else if (kept.length > 1) {
    parts.push(
      `${joinNames(kept)} estão desativados e não foram recriados; se quiser de volta, reative pela lista com "Mostrar desativados".`
    );
  }
  if (parts.length === 0) {
    return "Os canais padrão de rede já estão todos cadastrados.";
  }
  return parts.join(" ");
}
